import {InfoIcon} from '@primer/octicons-react'

import styles from './DeferredCardFieldsStatus.module.css'

export function DeferredCardFieldsStatus() {
  return (
    <div className={styles.Status}>
      <InfoIcon size={16} aria-hidden="true" />
      <span>Unable to load all details.</span>
    </div>
  )
}
